import { getPromoCodeCookie, getSessionIdCookie, removePromoCodeCookie } from './Session.utils';
import CarDetailsDuck from '../redux/carDetails/carDetails.duck';
import FinanceWidgetDuck from '../redux/financeWidget/financeWidget.duck';
import GlobalDuck from '../redux/global/global.duck';
import { DealService } from '../services';

export const checkUsedPromoCode = async (dispatch: any, isUserLoggedInAsDealer: boolean = false): Promise<void> => {
    const promoCode = getPromoCodeCookie();

    if (promoCode) {
        const { data } = isUserLoggedInAsDealer
            ? await DealService.applyPromoCodeAgentPortal(promoCode, getSessionIdCookie())
            : await DealService.applyPromoCode(promoCode, getSessionIdCookie(), true);

        if (!data?.success) {
            dispatch(GlobalDuck.setPromoCodeError(true));
            removePromoCodeCookie();
        }
        // deal & FQ does not have to be present on non-sucessful request depends if the promocode is removed
        if (data.deal) {
            dispatch(CarDetailsDuck.setCurrentDeal(data.deal));
            dispatch(CarDetailsDuck.setCurrentCarDetails(data.deal.fullProductConfiguration));
        }
        if (data.financeQuote) {
            dispatch(FinanceWidgetDuck.setFinanceQuote(data.financeQuote));
        }
    }
};
